export const SENSITIVITY_COLORS: Record<number, { bg: string; label: string; dot: string }> = {
  0: { bg: 'bg-green-500/20 text-green-400', label: 'Low', dot: 'bg-green-500' },
  1: { bg: 'bg-yellow-500/20 text-yellow-400', label: 'Mild', dot: 'bg-yellow-500' },
  2: { bg: 'bg-orange-500/20 text-orange-400', label: 'Medium', dot: 'bg-orange-500' },
  3: { bg: 'bg-red-500/20 text-red-400', label: 'High', dot: 'bg-red-500' },
  4: { bg: 'bg-red-900/30 text-red-300', label: 'Critical', dot: 'bg-red-800' },
};

export function SensitivityBadge({ level }: { level: number }) {
  const config = SENSITIVITY_COLORS[level] || SENSITIVITY_COLORS[0];
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium ${config.bg}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {config.label}
    </span>
  );
}

export function SensitivityDot({ level }: { level: number }) {
  const config = SENSITIVITY_COLORS[level] || SENSITIVITY_COLORS[0];
  return (
    <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium ${config.bg}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config.dot}`} />
      {config.label}
    </span>
  );
}
